import { logErrorToDatadog } from 'util/datadog';
import decamelizeKeys from 'util/decamelizeKeys';

export enum SegmentMethod {
  TRACK = 'track',
  PAGE = 'page',
  IDENTIFY = 'identify',
}

export function tryAnalytics<T extends SegmentMethod>(
  type: T,
  ...args: Parameters<WindowAnalytics[T]>
): void {
  try {
    // @ts-ignore: Typing with rest and spread created unexpected error, but works
    window.analytics[type](...args);
  } catch (error) {
    logErrorToDatadog(error, { extra: [...args] });
  }
}

export const frontendAnalyticsTrack = (
  event: string,
  properties: Record<string, unknown> = {}
): void => {
  const eventProperties = decamelizeKeys({
    ...properties,
    product: 'Life',
  });

  tryAnalytics(SegmentMethod.TRACK, event, eventProperties);
};

export const analyticsPage = (): void => {
  const { pathname, href } = window.location;

  tryAnalytics(SegmentMethod.PAGE, undefined, pathname, { url: href, path: pathname });
};

export const identify = (uuid: string, traits: Record<string, unknown> = {}): void => {
  tryAnalytics(SegmentMethod.IDENTIFY, uuid, decamelizeKeys(traits));
};

/*
 * DEPRECATION NOTICE:
 * `fastly_anonymous_id` is deprecated and `pg_wbid` will be replacing it. We will capture both cookie
 * values during Data Engineering's migration to the new cookie. Once they are fully migrated we will
 * remove `fastly_anonymous_id` from the `identifyVisitorId` function.
 */
export const identifyVisitorId = (uuid: string) => {
  const fastlyAnonymousId = document.cookie.match(new RegExp('(^| )fastly_anonymous_id=([^;]+)'));
  const pgWbid = document.cookie.match(new RegExp('(^| )pg_wbid=([^;]+)'));

  if (!window.analytics || !fastlyAnonymousId || !pgWbid) {
    return setTimeout(() => {
      identifyVisitorId(uuid);
    }, 5000);
  }

  identify(uuid, { visitorId: fastlyAnonymousId[2], webBrowserUuid: pgWbid[2] });
};
